var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconSaveLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#2DA4AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74023 6.83252C4.89062 6.40674 5.13477 6.00635 5.47852 5.66455C6.69922 4.44385 8.67773 4.44385 9.89844 5.66455L10.2324 6.00049H9.25C8.9043 6.00049 8.625 6.27978 8.625 6.62549C8.625 6.97119 8.9043 7.25049 9.25 7.25049H11.7402H11.748C12.0938 7.25049 12.373 6.97119 12.373 6.62549V4.12549C12.373 3.77979 12.0938 3.50049 11.748 3.50049C11.4023 3.50049 11.123 3.77979 11.123 4.12549V5.12549L10.7812 4.78174C9.07227 3.07275 6.30273 3.07275 4.59375 4.78174C4.11719 5.2583 3.77344 5.81885 3.5625 6.41846C3.44727 6.74463 3.61914 7.1001 3.94336 7.21533C4.26758 7.33057 4.625 7.15869 4.74023 6.83447V6.83252ZM3.44922 8.52588C3.35156 8.55518 3.25781 8.60791 3.18164 8.68604C3.10352 8.76416 3.05078 8.85791 3.02344 8.95947C3.01758 8.98291 3.01172 9.0083 3.00781 9.03369C3.00195 9.06689 3 9.1001 3 9.1333V11.6255C3 11.9712 3.2793 12.2505 3.625 12.2505C3.9707 12.2505 4.25 11.9712 4.25 11.6255V10.6274L4.59375 10.9692C6.30273 12.6763 9.07227 12.6763 10.7793 10.9692C11.2559 10.4927 11.6016 9.93213 11.8125 9.33447C11.9277 9.0083 11.7559 8.65283 11.4316 8.5376C11.1074 8.42236 10.75 8.59424 10.6348 8.91846C10.4844 9.34424 10.2402 9.74463 9.89648 10.0864C8.67578 11.3071 6.69727 11.3071 5.47656 10.0864L5.47461 10.0845L5.14062 9.75049H6.125C6.4707 9.75049 6.75 9.47119 6.75 9.12549C6.75 8.77979 6.4707 8.50049 6.125 8.50049H3.63281C3.60156 8.50049 3.57031 8.50244 3.53906 8.50635C3.50781 8.51025 3.47852 8.51611 3.44922 8.52588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconSaveLoading);
export default __webpack_public_path__ + "static/media/SDS_icon_SaveLoading.1ce6e493f581f946360aefc8cb15f186.svg";
export { ForwardRef as ReactComponent };